import React from 'react';
import { CheckIcon } from 'lucide-react';
import { roadmap } from '../data/profile';
import { SectionHeading } from './SectionHeading';
export function Roadmap() {
  return <section id="rumbo" className="border-b border-hairline py-24 lg:py-32" data-id="element-221" data-mp="14vx6xyyykiy2">
      <div className="mx-auto max-w-6xl px-6" data-id="element-222" data-mp="14tu76n807bg5">
        <SectionHeading index="07 — Rumbo" title="Hacia dónde va Labs" description="El plan está publicado y se actualiza a medida que avanza. Lo que todavía no está hecho también figura." data-id="element-223" data-mp="zxlwbm0ua4es" />

        <ol className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-hairline bg-hairline md:grid-cols-2 lg:grid-cols-4" data-id="element-224" data-mp="qukqznjsshc6">
          {roadmap.map(phase => <li key={phase.phase} className="flex flex-col bg-panel p-6" data-id="element-225" data-mp="gyre23262ltv">
              <div className="flex items-center justify-between" data-id="element-226" data-mp="2gatvl7r8d64w">
                <span className={`font-mono text-xs uppercase tracking-widest ${phase.done ? 'text-teal' : 'text-ink-mid'}`} data-id="element-227" data-mp="2g8zmcqpbn2gn">
                  {phase.phase}
                </span>
                {phase.done ? <span className="flex items-center gap-1 font-mono text-[11px] text-teal" data-id="element-228" data-mp="2o791c5ch5y57">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-229" data-mp="2a7px3nmsb6y6" />
                    Hecho
                  </span> : <span className="font-mono text-[11px] text-ink-mid" data-id="element-230" data-mp="32v2j9wp19cqy">Pendiente</span>}
              </div>

              <h3 className="mt-4 font-mono text-xl font-medium text-ink-hi" data-id="element-231" data-mp="37svl6djazklf">{phase.title}</h3>

              <ul className="mt-4 space-y-2 text-[14px] leading-relaxed text-ink-mid" data-id="element-232" data-mp="2t5slq1bf71vg">
                {phase.items.map(item => <li key={item} className="flex gap-2.5" data-id="element-233" data-mp="2y29ej8tke4ev">
                    <span className={`mt-2 h-1 w-1 shrink-0 rounded-full ${phase.done ? 'bg-teal' : 'bg-hairline'}`} aria-hidden="true" data-id="element-234" data-mp="3ltepb9kne6ib" />
                    {item}
                  </li>)}
              </ul>
            </li>)}
        </ol>
      </div>
    </section>;
}